import { dateFormat, rupiahFormat } from "../utils/format";

export const EventTracking = ({ trackingDetails, cuttingPlanEvents }) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 mt-0 sm:mt-8 font-Rubik text-base sm:text-[15px] font-semibold text-[#787878]">
      <div className="col-span-1 text-center">
        <div className="bg-[#F5F5F5] py-1 font-light">
          <h3>Produk</h3>
        </div>
        {trackingDetails?.map((detail, index) => (
          <h4 key={index + 1} className="my-4 max-w-[400px] mx-auto ">
            {detail.program}
          </h4>
        ))}
      </div>
      <div className=" text-center">
        <div className="bg-[#F5F5F5] py-1 font-light">
          <h3>Jumlah Pembayaran</h3>
        </div>
        {trackingDetails?.map((detail, index) => (
          <h3 key={index + 1} className="my-4 max-w-[200px] mx-auto ">
            {rupiahFormat(detail.amount)}
          </h3>
        ))}
      </div>
      <div className=" text-center">
        <div className="bg-[#F5F5F5] py-1 font-light">
          <h3>Nomor Hewan</h3>
        </div>
        {cuttingPlanEvents.length > 0
          && cuttingPlanEvents.map((nomor) => (
              <h3 key={nomor.id} className="my-4 max-w-[200px] mx-auto ">
                {nomor.meta.neats_number}
              </h3>
            ))
          }
      </div>
      <div className=" text-center">
        <div className="bg-[#F5F5F5] py-1 font-light">
          <h3>Rencana Pemotongan</h3>
        </div>
        {cuttingPlanEvents.length > 0
          && cuttingPlanEvents.map((tgl) => (
              <h1 key={tgl.id} className="my-4 max-w-[200px] text-[#82BE41] mx-auto">
                {dateFormat(tgl.meta.cutting_plan_at)}
              </h1>
            ))
          }
      </div>
    </div>
  );
}